import React from 'react';
import { styles } from './CartProductNotAvailableAlert.css';
import { JBAlert } from '@jbhi-fi/lanyard-ui';
import { Image } from '@jbhi-fi/components/src/PlatformFunctionality';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';

export type CartProductNotAvailableAlertProps = {
  heading: string;
  message: string;
  productImageUrl: string;
  productTitle: string;
  marketplaceSeller?: string;
  lineId: string;
  isCartPage?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, lineId: string) => void;
};

export const CartProductNotAvailableAlert = ({
  heading,
  message,
  productImageUrl,
  productTitle,
  marketplaceSeller,
  lineId,
  isCartPage,
  onClick,
}: CartProductNotAvailableAlertProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const shouldUseLargeLayout = isDesktop && isCartPage;
  return (
    <JBAlert type="error" heading={heading} showIcon classes={styles.container}>
      <p style={{ margin: 0 }}>{message}</p>
      <div className={styles.content}>
        <Image
          src={productImageUrl}
          alt="product image"
          width={shouldUseLargeLayout ? 80 : 40}
          height={shouldUseLargeLayout ? 80 : 40}
          className={styles.imageContainer}
        />
        <div className={styles.textContainer}>
          <p className={styles.productText}>{productTitle}</p>
          {marketplaceSeller ? (
            <p className={styles.marketplaceText}>
              <b>JB Hi-Fi Marketplace: </b>Sold and sent by {marketplaceSeller}
            </p>
          ) : null}
          {!shouldUseLargeLayout ? (
            <Button
              type="primary"
              classes={styles.buttonContainer({ shouldUseLargeLayout })}
              onClick={e => onClick(e, lineId)}
              label="Remove"
            />
          ) : null}
        </div>
        {shouldUseLargeLayout ? (
          <Button
            type="primary"
            classes={styles.buttonContainer({ shouldUseLargeLayout })}
            onClick={e => onClick(e, lineId)}
            label="Remove"
          />
        ) : null}
      </div>
    </JBAlert>
  );
};
